package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.GET_MERCHANT_BAGS
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class GetMerchantBagsRequestModel(
    val merchantId: Long,
    val locationId: Long? = null, // null = "All"
    val segment: String? = null // "active" or "ended"
) : BaseRequestModel(api = GET_MERCHANT_BAGS)

